import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import LoginPage from "@/views/Login.vue";
import DashboardPage from "@/views/Dashboard.vue";
import TradeListPage from "@/views/TradeList.vue";
import TradeOptionsPage from "@/views/TradeOptions.vue";
import { getAuth, onAuthStateChanged } from "firebase/auth"; // Import Firebase Auth

const routes: Array<RouteRecordRaw> = [
  { path: "/", name: "LoginPage", component: LoginPage },
  { path: "/dashboard", name: "DashboardPage", component: DashboardPage },
  { path: "/trades/:date", name: "TradeListPage", component: TradeListPage },
  {
    path: "/trade-options/:tradeId",
    name: "TradeOptionsPage",
    component: TradeOptionsPage,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// Vérifier l'authentification avant chaque navigation
router.beforeEach((to, from, next) => {
  const auth = getAuth();

  onAuthStateChanged(auth, (user) => {
    if (user && to.name === "LoginPage") {
      // Si l'utilisateur est connecté et va sur la page Login, on le redirige au Dashboard
      next({ name: "DashboardPage" });
    } else {
      // Sinon, on le laisse aller à la page demandée
      next();
    }
  });
});

export default router;
